<template>
  <div class="custom-footer">
    <portalLayoutPart part="footer" />
  </div>
</template>

<style lang="scss" scoped>
.custom-footer {
  position: relative;
  background-color: white;
}
</style>
